<alaris-dialog
	[closeAction]="close.bind(this)"
	[confirmAction]="confirm.bind(this)"
	[loading$]="sourcesService.loading$"
	[confirmButtonText]="'gl.delete'"
	size="md"
	class="removingDialog">
	<h3 slot="header">
		<app-circle-warning></app-circle-warning>
		<div>
			{{ 'sources.removingDialogTitle' | translate }}
		</div>
	</h3>
	<div slot="content">
		<p>
			@if (rules) {
			{{ 'sources.removingErrorDialog' | translate }}
			@for (id of rules; track id) {
			<li>
				<strong>{{ 'rules.id' | translate }}: {{ id }}</strong>
			</li>
			} } @else {
			{{ 'sources.removingDialog' | translate }}
			<strong>{{ data.source.Name }}</strong>
			}
		</p>
	</div>
</alaris-dialog>
